/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/ban-ts-ignore */

import { SEO_LANDING } from '../constants/templateConstants';
import delayedScheduler from '../scheduler';

export const trackCityTemplateEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const CITY_TEMPLATE_OMNITURE_PAGE_NAME = 'funnel:domestic cabs:city seo';
    try {
      // @ts-ignore
      const { s, cityName } = window;
      s.pageName = CITY_TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars =
        'channel,eVar1,eVar3,eVar15,eVar24,eVar34,prop24,prop54';
      s.eVar3 = `${cityName}`;
      s.eVar24 = `domestic cabs`;
      s.prop24 = 'domestic cabs';
      s.prop54 = eventWithValToTrack;

      // @ts-ignore
      s.tl(this, CITY_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackAirportTemplateEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Mob_Cab_Load_Error';
    const AIRPORT_TEMPLATE_OMNITURE_PAGE_NAME =
      'funnel:domestic cabs:airport seo';
    try {
      // @ts-ignore
      const { s, airportName } = window;
      s.pageName = AIRPORT_TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars = 'channel,eVar3,eVar15,eVar24,prop24,prop54';
      s.eVar3 = airportName;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop24 = 'domestic cabs';
      s.prop54 = eventWithValToTrack;

      // @ts-ignore
      s.tl(this, AIRPORT_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackCityOperatorTemplateEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Mob_Cab_Load_Error';
    const CITY_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME =
      'funnel:domestic cabs:city Operator seo';
    try {
      // @ts-ignore
      const { s, cityName, operatorName } = window;
      s.pageName = CITY_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars =
        'channel,eVar3,eVar15,eVar24,eVar82,prop24,prop3,prop54';
      s.eVar3 = cityName;
      s.eVar15 = CITY_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.eVar82 = operatorName;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(
        this,
        CITY_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME,
        eventWithValToTrack
      );
    } catch (e) {}
  });
};

export const trackCityRydeTemplateEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Mob_Cab_Load_Error';
    const RYDE_CITY_TEMPLATE_OMNITURE_PAGE_NAME = 'seo:domestic cabs:Ryde-city';
    try {
      // @ts-ignore
      const { s, cityName, rydeString } = window;
      s.pageName = RYDE_CITY_TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars =
        'channel,eVar3,eVar15,eVar24,eVar82,prop24,prop3,prop54';
      s.eVar3 = cityName;
      s.eVar15 = RYDE_CITY_TEMPLATE_OMNITURE_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.eVar82 = rydeString;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, RYDE_CITY_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackRouteRydeTemplateEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Mob_Cab_Load_Error';
    const RYDE_ROUTE_TEMPLATE_OMNITURE_PAGE_NAME =
      'seo:domestic cabs:Ryde-route';
    try {
      // @ts-ignore
      const { s, cityName, rydeString } = window;
      s.pageName = RYDE_ROUTE_TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars =
        'channel,eVar3,eVar15,eVar24,eVar82,prop24,prop3,prop54';
      s.eVar3 = cityName;
      s.eVar15 = RYDE_ROUTE_TEMPLATE_OMNITURE_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.eVar82 = rydeString;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, RYDE_ROUTE_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackEPassPageEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Cab_SEO_ePass_Load_Error';
    const EPASS_PAGE_NAME = 'seo:domestic cabs:ePass';
    try {
      // @ts-ignore
      const { s } = window;
      s.pageName = EPASS_PAGE_NAME;
      s.linkTrackVars = 'channel,eVar15,eVar24,prop54';
      s.eVar15 = EPASS_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, EPASS_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackOneWayCabPageEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Cab_SEO_One_Way_Load_Error';
    const ONE_WAY_PAGE_NAME = 'seo:domestic cabs:OneWay Cab';
    try {
      // @ts-ignore
      const { s } = window;
      s.pageName = ONE_WAY_PAGE_NAME;
      s.linkTrackVars = 'channel,eVar15,eVar24,prop54';
      s.eVar15 = ONE_WAY_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, ONE_WAY_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackRydeHomePageCabPageEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Cab_SEO_Ryde_Home_Page_Load_Error';
    const RYDE_HOME_PAGE_NAME = 'seo:domestic cabs:RydeHome Cab';
    try {
      // @ts-ignore
      const { s } = window;
      s.pageName = RYDE_HOME_PAGE_NAME;
      s.linkTrackVars = 'channel,eVar15,eVar24,prop54';
      s.eVar15 = RYDE_HOME_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, RYDE_HOME_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackRentalHomePageCabPageEvent = (
  eventWithValToTrack: string
) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Cab_SEO_Rental_Home_Page_Load_Error';
    const RENTAL_HOME_PAGE_NAME = 'seo:domestic cabs:RentalHome';
    try {
      // @ts-ignore
      const { s } = window;
      s.pageName = RENTAL_HOME_PAGE_NAME;
      s.linkTrackVars = 'channel,eVar15,eVar24,prop54';
      s.eVar15 = RENTAL_HOME_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, RENTAL_HOME_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackAirportHomePageCabPageEvent = (
  eventWithValToTrack: string
) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Cab_SEO_Airport_Home_Page_Load_Error';
    const AIRPORT_HOME_PAGE_NAME = 'seo:domestic cabs:Airport taxi';
    try {
      // @ts-ignore
      const { s } = window;
      s.pageName = AIRPORT_HOME_PAGE_NAME;
      s.linkTrackVars = 'channel,eVar15,eVar24,prop54';
      s.eVar15 = AIRPORT_HOME_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, AIRPORT_HOME_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackRouteOperatorTemplateEvent = (
  eventWithValToTrack: string
) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Mob_Cab_Load_Error';
    const ROUTE_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME =
      'seo:domestic cabs:route Operator';
    try {
      // @ts-ignore
      const { s, sourceCityName, destinationCityName, operatorName } = window;
      s.pageName = ROUTE_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars =
        'channel,eVar3,eVar15,eVar24,eVar82,prop24,prop3,prop54';
      s.eVar3 = `${sourceCityName} | ${destinationCityName}`;
      s.eVar15 = ROUTE_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.eVar82 = operatorName;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(
        this,
        ROUTE_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME,
        eventWithValToTrack
      );
    } catch (e) {}
  });
};

export const trackOperatorTemplateEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Mob_Cab_Load_Error';
    const OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME = 'seo:domestic cabs:Operator';
    try {
      // @ts-ignore
      const { s, name: operatorName } = window;
      s.pageName = OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar3 = `|`;
      s.eVar15 = OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.eVar82 = operatorName;
      s.prop54 = eventWithValToTrack;
      s.linkTrackVars = 'channel,eVar3,eVar15,eVar24,eVar82,prop54';

      // @ts-ignore
      s.tl(this, OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackRouteTemplateEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Mob_Cab_Load_Error';
    const ROUTE_TEMPLATE_OMNITURE_PAGE_NAME = 'seo:domestic cabs:route-new';
    try {
      // @ts-ignore
      const { s, sourceCityName, destinationCityName } = window;
      s.pageName = ROUTE_TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars =
        'channel,eVar3,eVar15,eVar24,prop24,prop3,prop54,eVar97';
      s.eVar3 = `${sourceCityName} | ${destinationCityName}`;
      s.eVar15 = ROUTE_TEMPLATE_OMNITURE_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, ROUTE_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};
export const trackRouteCarTypeTemplateEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Mob_Cab_Load_Error';
    const ROUTE_CAR_TYPE_TEMPLATE_OMNITURE_PAGE_NAME =
      'seo:domestic cabs:route carType';
    try {
      // @ts-ignore
      const { s, sourceCityName, destinationCityName, carTypeName } = window;
      s.pageName = ROUTE_CAR_TYPE_TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars =
        'channel,eVar3,eVar15,eVar24,eVar82,prop24,prop3,prop54';
      s.eVar3 = `${sourceCityName} | ${destinationCityName}`;
      s.eVar15 = ROUTE_CAR_TYPE_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar82 = carTypeName;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(
        this,
        ROUTE_CAR_TYPE_TEMPLATE_OMNITURE_PAGE_NAME,
        eventWithValToTrack
      );
    } catch (e) {}
  });
};

export const trackCityCarTypeTemplateEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Mob_Cab_Load_Error';
    const CITY_CAR_TYPE_TEMPLATE_OMNITURE_PAGE_NAME =
      'seo:domestic cabs:city carType';
    try {
      // @ts-ignore
      const { s, cityName, carTypeName } = window;
      s.pageName = CITY_CAR_TYPE_TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars =
        'channel,eVar3,eVar15,eVar24,eVar82,prop24,prop3,prop54';
      s.eVar3 = cityName;
      s.eVar15 = CITY_CAR_TYPE_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar82 = carTypeName;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(
        this,
        CITY_CAR_TYPE_TEMPLATE_OMNITURE_PAGE_NAME,
        eventWithValToTrack
      );
    } catch (e) {}
  });
};

export const trackCityHRTemplateEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const ERROR_CODE = 'Mob_Cab_Load_Error';
    const HR_CITY_TEMPLATE_OMNITURE_PAGE_NAME = 'seo:domestic cabs:hr-city';
    try {
      // @ts-ignore
      const { s, cityName, hrString } = window;
      s.pageName = HR_CITY_TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars =
        'channel,eVar3,eVar15,eVar24,eVar82,prop24,prop3,prop54';
      s.eVar3 = cityName;
      s.eVar15 = HR_CITY_TEMPLATE_OMNITURE_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.eVar82 = hrString;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, HR_CITY_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};
export const trackAirportToCityRouteTemplateEvent = (
  eventWithValToTrack: string
) => {
  delayedScheduler(() => {
    const TEMPLATE_OMNITURE_PAGE_NAME = 'seo:domestic cabs:a2c-route';
    try {
      // @ts-ignore
      const { s, airportName, destinationCityName } = window;
      s.pageName = TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars =
        'channel,eVar3,eVar15,eVar24,prop24,prop3,prop54,eVar97';
      s.eVar3 = `${airportName} | ${destinationCityName}`;
      s.eVar15 = TEMPLATE_OMNITURE_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackCityToAirportRouteTemplateEvent = (
  eventWithValToTrack: string
) => {
  delayedScheduler(() => {
    const TEMPLATE_OMNITURE_PAGE_NAME = 'seo:domestic cabs:c2a-route';
    try {
      // @ts-ignore
      const { s, airportName, destinationCityName } = window;
      s.pageName = TEMPLATE_OMNITURE_PAGE_NAME;
      s.linkTrackVars =
        'channel,eVar3,eVar15,eVar24,prop24,prop3,prop54,eVar97';
      s.eVar3 = `${airportName} | ${destinationCityName}`;
      s.eVar15 = TEMPLATE_OMNITURE_PAGE_NAME;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackCabsLandingPageEvent = (eventWithValToTrack: string) => {
  delayedScheduler(() => {
    const CABS_LANDING_PAGE_NAME = 'landing:domestic cabs:landing-New';
    try {
      // @ts-ignore
      const { s } = window;
      s.pageName = CABS_LANDING_PAGE_NAME;
      s.linkTrackVars = 'channel,eVar15,eVar24,prop54,prop69';
      s.eVar15 = CABS_LANDING_PAGE_NAME;
      s.prop69 = SEO_LANDING;
      // s.eVar22 = ERROR_CODE;
      s.eVar24 = `domestic cabs`;
      s.prop54 = eventWithValToTrack;
      // @ts-ignore
      s.tl(this, CABS_LANDING_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackAdView = (eventWithValToTrack: string) => {
  const templateName =
    window['__INITIAL_STATE__']['templateData']['templateName'];
  if (templateName === 'city')
    trackCityTemplateEvent(
      eventWithValToTrack.replace('Template', 'City_Template')
    );
  else if (templateName === 'route')
    trackRouteTemplateEvent(
      eventWithValToTrack.replace('Template', 'Route_Template')
    );
  else if (templateName === 'operator')
    trackOperatorTemplateEvent(
      eventWithValToTrack.replace('Template', 'Operator_Template')
    );
  else if (templateName === 'city_operator')
    trackCityOperatorTemplateEvent(
      eventWithValToTrack.replace('Template', 'City_Operator_Template')
    );
  else if (templateName === 'route_operator')
    trackRouteOperatorTemplateEvent(
      eventWithValToTrack.replace('Template', 'Route_Operator_Template')
    );
  else if (templateName === 'airport')
    trackAirportTemplateEvent(
      eventWithValToTrack.replace('Template', 'Airport_Template')
    );
  else if (templateName === 'route_car_type')
    trackRouteCarTypeTemplateEvent(
      eventWithValToTrack.replace('Template', 'Route_Car_Type_Template')
    );
  else if (templateName === 'city_car_type')
    trackCityCarTypeTemplateEvent(
      eventWithValToTrack.replace('Template', 'City_Car_Type_Template')
    );
  else if (templateName === 'city_ryde')
    trackCityRydeTemplateEvent(
      eventWithValToTrack.replace('Template', 'City_Ryde_Template')
    );
  else if (templateName === 'route_ryde')
    trackRouteRydeTemplateEvent(
      eventWithValToTrack.replace('Template', 'Route_Ryde_Template')
    );
  else if (templateName === 'static-one-way-cab')
    trackOneWayCabPageEvent(
      eventWithValToTrack.replace('Template', 'One_Way_Page')
    );
  else if (templateName === 'static-airport-taxi')
    trackAirportHomePageCabPageEvent(
      eventWithValToTrack.replace('Template', 'Airport_Home_Page')
    );
  else if (templateName === 'static-ryde-cab')
    trackRydeHomePageCabPageEvent(
      eventWithValToTrack.replace('Template', 'Ryde_Home_Page')
    );
  else if (templateName === 'city_hr')
    trackCityHRTemplateEvent(
      eventWithValToTrack.replace('Template', 'City_HR_Template')
    );
  else if (templateName === 'static-rental-taxi')
    trackRentalHomePageCabPageEvent(
      eventWithValToTrack.replace('Template', 'Rental_Home_Template')
    );
  else if (templateName === 'airport_to_city_route')
    trackAirportToCityRouteTemplateEvent(
      eventWithValToTrack.replace('Template', 'A2C_Route_Template')
    );
};
